import React from 'react';
import Button from '@material-ui/core/Button';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import VisibilityIcon from '@material-ui/icons/Visibility';
import { makeStyles } from '@material-ui/core/styles';

// Фильтры вынесены из-под иконки-воронки mui-datatables наружу: собрать
// список фильтром — основной рабочий сценарий, он не должен быть спрятан.
// Поиск живёт в закреплённой панели выше: он нужен чаще остальных фильтров.
const useStyles = makeStyles((theme) => ({
  row: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'flex-start',
    marginBottom: theme.spacing(1.5),
  },
  select: {
    minWidth: 170,
    marginRight: theme.spacing(1.5),
    marginBottom: theme.spacing(1.5),
  },
  actions: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    marginBottom: theme.spacing(2),
  },
  action: {
    marginRight: theme.spacing(1.5),
    textTransform: 'none',
  },
}));

const ANY = '';

function ContactFilters(props) {
  const classes = useStyles();
  const {
    hasSearch,
    type,
    onTypeChange,
    region,
    onRegionChange,
    consent,
    onConsentChange,
    types,
    regions,
    selectedCount,
    showSelectedOnly,
    onToggleSelectedOnly,
    onReset,
  } = props;

  const hasFilter =
    hasSearch || type !== ANY || region !== ANY || consent !== ANY;

  return (
    <div>
      <div className={classes.row}>
        <TextField
          select
          className={classes.select}
          variant="outlined"
          size="small"
          label="Тип компании"
          value={type}
          onChange={(event) => onTypeChange(event.target.value)}
        >
          <MenuItem value={ANY}>Любой</MenuItem>
          {types.map((item) => (
            <MenuItem key={item} value={item}>
              {item}
            </MenuItem>
          ))}
        </TextField>
        <TextField
          select
          className={classes.select}
          variant="outlined"
          size="small"
          label="Область"
          value={region}
          onChange={(event) => onRegionChange(event.target.value)}
        >
          <MenuItem value={ANY}>Любая</MenuItem>
          {regions.map((item) => (
            <MenuItem key={item} value={item}>
              {item}
            </MenuItem>
          ))}
        </TextField>
        <TextField
          select
          className={classes.select}
          variant="outlined"
          size="small"
          label="Согласие"
          value={consent}
          onChange={(event) => onConsentChange(event.target.value)}
        >
          <MenuItem value={ANY}>Любое</MenuItem>
          <MenuItem value="confirmed">Подтверждён</MenuItem>
          <MenuItem value="pending">Ждём ответа</MenuItem>
          <MenuItem value="declined">Отказался</MenuItem>
          <MenuItem value="none">Не запрашивали</MenuItem>
          <MenuItem value="nodoc">Подтверждён, но без документа</MenuItem>
        </TextField>
      </div>

      <div className={classes.actions}>
        <Button
          className={classes.action}
          size="small"
          variant={showSelectedOnly ? 'contained' : 'outlined'}
          color="primary"
          disableElevation
          startIcon={<VisibilityIcon />}
          disabled={selectedCount === 0}
          onClick={onToggleSelectedOnly}
        >
          {showSelectedOnly ? 'Показать всю базу' : 'Показать выбранные'}
        </Button>
        {hasFilter && !showSelectedOnly && (
          <Button className={classes.action} size="small" onClick={onReset}>
            Сбросить фильтры
          </Button>
        )}
      </div>
    </div>
  );
}

export default ContactFilters;
